import React from "react";
import { Box, Typography } from "@mui/material";

const titleSx = { mt: 3, mb: 1, fontWeight: 700 };
const labelSx = { width: "200px", fontWeight: 700, flexShrink: 0 };
const valueSx = {
  flex: 1,
  borderBottom: "1px solid #999",
  minHeight: "20px",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
};
const rowSx = { display: "flex", gap: 12, mb: 1.2, alignItems: "flex-start" };

const boolText = (value) => {
  if (value === true) return "あり";
  if (value === false) return "なし";
  return "";
};

const valueOrEmpty = (value) => value ?? "";

const Comp16PDF = ({ formData }) => {
  if (!formData) return null;

  const submission = formData.o16?.[0] ?? formData;
  const details = submission.details ?? [];
  const subDetails = submission.sub_details ?? [];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        食品取扱関係調査票
      </Typography>

      <Box sx={rowSx}>
        <Typography sx={labelSx}>小間番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.booth_number || formData.booth_number)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>会社名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.company_name || formData.company_name)}</Box>
      </Box>

      <Typography sx={titleSx}>担当者情報</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>担当者名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_16_name || formData.user_name)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>部署</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_16_department || formData.department)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>会社電話番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_16_phone || formData.phone_number)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>携帯電話番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_16_tel)}</Box>
      </Box>

      <Typography sx={titleSx}>現場管理責任者</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>会社名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.onsite_manager_company)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>担当者名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.onsite_manager_name)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>電話番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.onsite_manager_phone)}</Box>
      </Box>

      <Typography variant="h6" sx={{ mb: 3 }}>
        食品取扱関係調査票
      </Typography>

      <Typography sx={titleSx}>試食・試飲および試供品提供申込</Typography>
      {subDetails.length === 0 && <Typography>入力なし</Typography>}
      {subDetails.map((detail, index) => (
        <Box key={`sub-${index}`} sx={{ mb: 2, pl: 1 }}>
          <Typography sx={{ mb: 1, fontWeight: 700 }}>{`項目 ${index + 1}`}</Typography>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>品名</Typography>
            <Box sx={valueSx}>{valueOrEmpty(detail.sales_item_name)}</Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>設置する設備</Typography>
            <Box sx={valueSx}>{valueOrEmpty(detail.equipment_installed)}</Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>試食・試飲</Typography>
            <Box sx={valueSx}>{`${boolText(detail.tasting)} '-内容: ' ${valueOrEmpty(detail.tasting_notes)}`.trim()}</Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>試供品</Typography>
            <Box sx={valueSx}>
              {`${boolText(detail.sample_distribution)} '-内容: ' ${valueOrEmpty(detail.sample_distribution_notes)}`.trim()}
            </Box>
          </Box>
        </Box>
      ))}

      <Typography sx={titleSx}>現場管理責任者</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>会社名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.onsite_manager_company)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>担当者名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.onsite_manager_name)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>電話番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.onsite_manager_phone)}</Box>
      </Box>

      <Typography sx={titleSx}>食品販売申込</Typography>
      {details.length === 0 && <Typography>入力なし</Typography>}
      {details.map((detail, index) => (
        <Box key={`food-${index}`} sx={{ mb: 2, pl: 1 }}>
          <Typography sx={{ mb: 1, fontWeight: 700 }}>{`販売食品 ${index + 1}`}</Typography>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>品名</Typography>
            <Box sx={valueSx}>{valueOrEmpty(detail.food_item)}</Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>提供方法</Typography>
            <Box sx={valueSx}>{valueOrEmpty(detail.food_sales_method)}</Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>価格 / 数量 / 合計</Typography>
            <Box sx={valueSx}>
              {`${valueOrEmpty(detail.food_price)} / ${valueOrEmpty(detail.food_quantity)} / ${valueOrEmpty(detail.food_price_all)}`}
            </Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>商品保証方法</Typography>
            <Box sx={valueSx}>{valueOrEmpty(detail.food_warranty_method)}</Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>衛生管理方法</Typography>
            <Box sx={valueSx}>{valueOrEmpty(detail.hygiene_management)}</Box>
          </Box>
        </Box>
      ))}
      <Box sx={rowSx}>
        <Typography sx={labelSx}>売上金額合計（税込）</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.food_price_all_contains)}</Box>
      </Box>

      <Typography sx={titleSx}>会期後販売責任者</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>責任者区分</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.post_event_sales_responsible)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>会社名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.post_event_manager_company)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>担当者名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.post_event_manager_name)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>電話番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.post_event_manager_phone)}</Box>
      </Box>

      <Typography sx={titleSx}>備考</Typography>
      <Box sx={valueSx}>{valueOrEmpty(submission.alfa_text)}</Box>
    </Box>
  );
};

export default Comp16PDF;
